import { GlobalAppState } from 'rdx/state';
import { HttpErrorUtils } from '@bolteu/http-client/src/errors/HttpErrorUtils';
import { HttpResponseErrorBoltServer } from '@bolteu/http-normalizer-bolt-server';

export const selectPasswordRequestState = (state: GlobalAppState) => {
  return state.password.requestState;
};

export const selectPasswordValidationErrors = (state: GlobalAppState) => {
  if (!state.password.errors) {
    return null;
  }

  const error = state.password.errors;
  if (!HttpErrorUtils.isInstanceOf(error, HttpResponseErrorBoltServer.ValidationError)) {
    return null;
  }

  return error.validatorResults.reduce((partial, current) => {
    if (!current.property) {
      return partial;
    }

    if (!partial[current.property.toString()]) {
      partial[current.property.toString()] = [];
    }

    partial[current.property.toString()].push(current.error);
    return partial;
  }, {} as { [key: string]: string[] });
};
